import { useQuery } from '@tanstack/react-query';

import { fetchClaimEmailStatus } from '../data-provider/claim-email-status';

export const useGetClaimEmailStatus = (claimKey: number | undefined) => {
  return useQuery({
    enabled: Boolean(claimKey),
    queryFn: () => fetchClaimEmailStatus({ claimKey: Number(claimKey) }),
    queryKey: ['claims-loss-and-damage-email-status', claimKey],
  });
};
